import React from 'react';
import { useTranslation } from 'react-i18next';
import './StrengthsWeaknesses.css';

interface Item {
    code: string;
    label: string;
    mastery: number;
}

interface Props {
    strengths: Item[];
    weaknesses: Item[];
}

const StrengthsWeaknesses: React.FC<Props> = ({ strengths, weaknesses }) => {
    const { t } = useTranslation('knowledgeGraph');

    const renderItem = (item: Item, type: 'strength' | 'weakness') => {
        const pct = Math.round(item.mastery * 100);
        return (
            <div key={item.code} className={`sw-item sw-item--${type}`}>
                <div className="sw-item__label">{item.label}</div>
                <div className="sw-item__bar">
                    <div
                        className="sw-item__fill"
                        style={{ width: `${pct}%` }}
                    />
                </div>
                <div className="sw-item__value">{pct}%</div>
            </div>
        );
    };

    return (
        <div className="strengths-weaknesses">
            <div className="sw-section">
                <h3 className="sw-section__title sw-section__title--strength">
                    {t('strengths')}
                </h3>
                {strengths.length === 0 ? (
                    <p className="sw-section__empty">{t('noDataYet')}</p>
                ) : (
                    strengths.map(item => renderItem(item, 'strength'))
                )}
            </div>
            <div className="sw-section">
                <h3 className="sw-section__title sw-section__title--weakness">
                    {t('weaknesses')}
                </h3>
                {weaknesses.length === 0 ? (
                    <p className="sw-section__empty">{t('noDataYet')}</p>
                ) : (
                    weaknesses.map(item => renderItem(item, 'weakness'))
                )}
            </div>
        </div>
    );
};

export default StrengthsWeaknesses;
